const data = {
  "publication-interdependence": {
    id: "publication-interdependence",
    short: "Task Interdependence",
    venue: "RO-MAN",
    title: "Task Interdependence in Human-Robot Teaming",
    reference:
      "Zhao, F., Henrichs, C., & Mutlu, B. (2020, August). Task Interdependence in Human-Robot Teaming. In 2020 29th IEEE International Conference on Robot and Human Interactive Communication (RO-MAN) (pp. 1143-1149). IEEE.",
    link: "https://ieeexplore.ieee.org/abstract/document/9223555",
    status: "Published"
  },
  "publication-authr": {
    id: "publication-authr",
    short: "Authr User Interface",
    venue: "UIST",
    title: "Authr: A Task Authoring Environment for Human-Robot Teams",
    reference:
      "Schoen, A., Henrichs, C., Strohkirch, M., & Mutlu, B. (2020, October). Authr: A Task Authoring Environment for Human-Robot Teams. In Proceedings of the 33rd Annual ACM Symposium on User Interface Software and Technology (pp. 1194-1208).",
    link: "https://dl.acm.org/doi/10.1145/3379337.3415872",
    status: "Published"
  },
  "publication-rad": {
    id: "publication-rad",
    short: "Operator Interface Aids",
    venue: "RO-MAN",
    title:
      "Designing Interface Aids to Assist Collaborative Robot Operators in Attention Management",
    reference:
      "Henrichs, C., Zhao, F., & Mutlu, B. (2021, August). Designing Interface Aids to Assist Collaborative Robot Operators in Attention Management. In 2021 30th IEEE International Conference on Robot & Human Interactive Communication (RO-MAN) (pp. 264-271). IEEE.",
    link: "https://ieeexplore.ieee.org/document/9515519",
    status: "Published"
  },
  "publication-onet": {
    id: "publication-onet",
    short: "Enhancing Work Activities",
    venue: "Human Factors",
    title: "Human Robot Collaboration for Enhancing Work Activities",
    reference:
      "Liu, L., Schoen, A. J., Henrichs, C., Li, J., Mutlu, B., Zhang, Y., & Radwin, R. G. (2022). Human Robot Collaboration for Enhancing Work Activities. Human Factors, 00187208221077722.",
    link: "https://journals.sagepub.com/doi/10.1177/00187208221077722",
    status: "Published"
  },
  "publication-coframe": {
    id: "publication-coframe",
    short: "CoFrame User Interface",
    venue: "HRI",
    title: "CoFrame: A System for Training Novice Cobot Programmers",
    reference:
      "Schoen, A., White, N. T., Henrichs, C., Siebert-Evenstone, A., Shaffer, D. W., & Mutlu, B. (2022, March). CoFrame: A System for Training Novice Cobot Programmers. In HRI (pp. 185-194).",
    link: "https://dl.acm.org/doi/abs/10.5555/3523760.3523788",
    status: "Published"
  },
  "publication-syn-tem": {
    id: "publication-syn-tem",
    short: "Spatiotemporal Dose Control",
    venue: "M&M",
    title:
      "Electrostatic Switching for Spatiotemporal Dose Control in a Transmission Electron Microscope",
    reference:
      "Reed, B. W., Bloom, R. S., Eyzaguirre, G., Henrichs, C., Moghadam, A. A., & Masiel, D. J. (2022). Electrostatic Switching for Spatiotemporal Dose Control in a Transmission Electron Microscope. Microscopy and Microanalysis, 28(S1), 2230-2231.",
    link: "https://academic.oup.com/mam/article-abstract/28/S1/2230/6996948",
    status: "Published"
  }
};

export default data;
